import IAdmissionRepository from "../4_Repositories/IAdmissionRepository";

export default class GetQuizzesUseCase {
  private readonly _repository: IAdmissionRepository;

  constructor(repository: IAdmissionRepository) {
    this._repository = repository;
  }

  public async execute(admissionExams: string, quizzesId: string) {
    const entities = await this._repository.getQuizzes(
      admissionExams,
      quizzesId
    );

    return entities.toJSON();
  }
}
